// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"45":"a062a0993cb349c2","169":"79f6812c326fafbc"}[chunkId] + ".css";
};